export enum CONTEST_NAME {
    SUCCESS_FORMULA = 'Формула Успеха',
    TIME_OF_THE_FIRST = 'Время первых',
}
